import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { EVENT } from '../../../shared/constants/dali.constants';
import { Changes, TagEvent } from '../../../shared/models/dali-tags.model';
import { IProductsModel } from '../../../shared/models/products.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import {
  ChannelCommunicatorService,
} from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from '../../../shared/services/tagging/tagging.service';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
})
export class ProductDetailComponent implements OnInit {

  productDesc;
  listTabs = [];
  currentTab = 1;
  platformActual: string;
  productSelected: IProductsModel;
  postLogin: boolean;
  product_type: string;
  channelId;

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private taggingService: TaggingService,
    private bioCatchService: BioCatchService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private channelCommunicatorService: ChannelCommunicatorService,
    public helper: HelpersService,
    private parametersService: ParametersService,
    private bitacoraService: BitacoraService,
    ) {
    this.headerService.show(false, false, true);
  }

  ngOnInit() {
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    const isEvidente = this.bioCatchService.isEvidenteCase();
    const isOriginal = product === ProductsBiocatchEnum.VIV && !this.abreCuentasService.getPostlogin() && !this.abreCuentasService.getIsPortal() ? true : false;
    this.bioCatchService.changeContext(StepBiocatchEnum.solicitud, product, isOriginal, isEvidente);
    this.postLogin = this.abreCuentasService.getPostlogin();
    this.productSelected = this.abreCuentasService.getproductSelected();
    this.product_type = this.productSelected.product_type;
    if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE && this.postLogin) {
      this.productDesc = this.productSelected.detail_product.dynamic_client_existing || null;
    } else {
      this.productDesc = this.productSelected.detail_product.dynamic || null;
    }
    this.listTabs = this.productDesc ? this.productDesc.tabs.map(data => data.title) : [];
  }

  onClickTab(event) {
    this.currentTab = event.current;
    this.pageTagEvent('1', 'click', event.selected);
  }

  handleLoadCallToAction(e) {
    if (e.target.className === 'call-to-action-links') {
      this.channelCommunicatorService.getImpl().openExternalBrowser(e.target.textContent, 5, true);
    } else if (e.target.className === 'show-required') {
      this.navigationService.nextStep('201');
    }
  }

  /**
   * Summary biocatch service usage
   *
   * @memberof ProductDetailComponent
   */
  checkBioCatch() {
    this.abreCuentasService.showGenericLoading();
    this.bioCatchService.checkCountry(false).then(response => {
      this.abreCuentasService.hideGenericLoading();
      if (response.data.response) {
        this.navigationService.nextStep();
      } else {
        this.navigationService.navigateToGeneralInformation('dsbException');
      }
    }, () => {
      this.abreCuentasService.hideGenericLoading();
      this.navigationService.navigateToGeneralInformation('500');
    }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  /**
   * @author cramos
   * @param eventNumber id number of event 1/2/3/4
   * @param customAction action of event click/show
   * @param customLabel custom label
   */
  pageTagEvent(eventNumber: string, customAction: string, customLabel?: string) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].path,
          value: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionDetailsProductcategory`].value,
        },
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].path,
          value: EVENT[`${tagPageName}E${eventNumber}setData`][`${tagPageName}E${eventNumber}transactionName`].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.link,
          position: EVENT.customCategory.position.top,
        },
        action: EVENT.customAction[customAction],
        label: customLabel ? this.navigationService.camelize(customLabel) : EVENT[`${tagPageName}E${eventNumber}customLabel`],
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Ejecuta el metodo previousStep de NavigationService
   *
   * *Executes previousStep function from NavigationService*
   */
  onPrevious() {
    this.navigationService.previousStep();
  }
}
